module.exports = __webpack_public_path__ + "img/profile_inactive.f6dd7b1d.svg";